"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$ = exports.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$outboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$inboundSchema = void 0;
exports.fastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPriceToJSON = fastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPriceToJSON;
exports.fastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPriceFromJSON = fastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPriceFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$inboundSchema = z.object({
    average_listing_price: z.nullable(z.number().int()),
    date: z.string().transform(v => new rfcdate_js_1.RFCDate(v)),
    total_properties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_listing_price": "averageListingPrice",
        "total_properties": "totalProperties",
    });
});
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$outboundSchema = z.object({
    averageListingPrice: z.nullable(z.number().int()),
    date: z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString()),
    totalProperties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averageListingPrice: "average_listing_price",
        totalProperties: "total_properties",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$;
(function (FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$) {
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$inboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$.inboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$inboundSchema;
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$outboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$.outboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$outboundSchema;
})(FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$ || (exports.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$ = FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$ = {}));
function fastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPriceToJSON(fastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice) {
    return JSON.stringify(exports.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$outboundSchema
        .parse(fastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice));
}
function fastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPriceFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice' from JSON`);
}
//# sourceMappingURL=fastapikrakenendpointsstatsmodelslettingslocalauthoritygetlistingpriceresponseslistingprice.js.map